"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesSocial = void 0;
var TypesSocial;
(function (TypesSocial) {
    TypesSocial["model"] = "social.model";
    TypesSocial["vibrationManager"] = "social.vibrationManager";
    TypesSocial["auth"] = "social.auth";
    TypesSocial["cookie"] = "social.cookie";
    TypesSocial["user"] = "social.user";
    TypesSocial["payments"] = "social.payments";
    TypesSocial["refRewardsModel"] = "social.irewards";
    TypesSocial["notifications"] = "social.notifications";
    TypesSocial["dummyUser"] = "social.dummyUser";
    TypesSocial["userScore"] = "social.user.score";
    TypesSocial["leaderboardGlobal"] = "social.leaderboard.global";
    TypesSocial["leaderboardContext"] = "social.leaderboard.context";
    TypesSocial["pauseAction"] = "social.pauseAction";
})(TypesSocial = exports.TypesSocial || (exports.TypesSocial = {}));
//# sourceMappingURL=TypesSocial.js.map